import axios from "axios";
import { getCookie } from "../../getcookie";
const apiUrl = process.env.REACT_APP_API_URL;

const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getVehicleDetailAPI = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_vehicle_details/` + id, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getFuelHistDetAPI = async (id) => {
  try {
    const response = await axios.get(apiUrl + `fuel_history/${id}`, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getFuelHistoryAPI = async (id) => {
  try {
    const response = await axios.get(apiUrl + `fuel_history/` + id, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const submitAPI = async (body) => {
  try {
    const response = await axios.post(apiUrl + `fuel_history`, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const addAttachmentApi = async (id, body) => {
  try {
    const response = await axios.put(
      apiUrl + `fuel_history/add_attachment/${id}`,
      body,
      {
        headers: header,
      }
    );
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const UpdateAPI = async (body, id) => {
  try {
    const response = await axios.put(apiUrl + `fuel_history/` + id, body, {
      headers: header,
    });
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
